<template>
  <BaseDialogTemplate
    v-model:open="openComputed"
  >
    <template v-slot:title>ログインIDまたはパスワードを忘れた場合</template>

    <div class="d-flex justify-center">
      <v-form
        @submit.prevent="passwordSuccess"
        class="signin-form">
        <v-container>
          <v-row class="d-flex justify-center">
            <v-col cols="6" class="mt-4">
              <p>ログインID･パスワードに関するお問い合わせは、営業担当までご連絡ください。</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex justify-center　mt-4">
              <Button
                styling="Flat"
                @click="cancelDialog">
                閉じる</Button>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>

    <!-- closeボタン -->
    <template v-slot:actions>
      <v-btn
      variant="text"
      @click="cancelDialog"
      icon="mdi-close"
      size="30"
    >
  </v-btn></template>
  </BaseDialogTemplate>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup'

import BaseDialogTemplate from '@/components/templates/BaseDialogTemplate.vue'
import Button from '@/components/molecules/buttons/Button.vue';

// Emits ------------------
interface Emits {
  (e: 'update:open', open: boolean): void,
  (e: 'success', loginId: any): void,
  (e: 'cancel'): void,
}
const emits = defineEmits<Emits>();

// Props ------------------
interface Props {
  open: boolean,
}
const props = withDefaults(defineProps<Props>(), {
  open: false,
});

// open ------------------
const { open } = toRefs(props)
const openComputed = computed({
  get: () => open.value,
  set: (value) => {
    emits('update:open', value)
  }
})


// Define fields
const { handleSubmit } = useForm()
const loginId = useField('loginId', yup.string().required('ログインIDを入力してください。'));

// キャンセル
const cancelDialog = () => {
  emits('cancel')
}

// 選択完了
const passwordSuccess = handleSubmit(() => {
  emits('success', loginId.value.value)
})
</script>

<style lang="scss" scoped>
.signin-form {
  width: 100%;
}
.input-header {
  font-size: 20px;
  font-weight: 700;
}

.dialog-heading {
  font-size: 24px;
  font-weight: 700;
}

.select-name {
  &::v-deep(.v-field__field) {
    display: flex;
    align-items: center;
    height: 40px;
  }
}

.input-area {
  font-size: 20px;

  &::v-deep(.v-field__field) {
    display: flex;
    align-items: center;
  }
  &::v-deep(.v-field__input) {
    font-size: 20px;
    line-height: 2;
    padding: 0 8px;

    input {
      margin: 0;
    }
  }

  &::v-deep(.v-input__control) {
    background-color: white;
  }
}
</style>
